var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"state"},[_c('img',{staticClass:"state__img",attrs:{"src":_vm.img}}),_c('h1',{staticClass:"state__heading"},[_vm._v(_vm._s(_vm.$t(_vm.heading)))]),(_vm.message)?_c('html-with-links',{staticClass:"state__status g-status",class:{
      'g-status_error': _vm.state === 'error',
      'g-status_success': _vm.state === 'success',
    },attrs:{"tag":"span","html":_vm.$t(_vm.message)}}):_vm._e(),_c('a',{staticClass:"g-button",on:{"click":function($event){$event.preventDefault();return _vm.go.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t(_vm.linkText)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }